import { StorageKey } from '@/plugins/storage'
import { hamiVuex } from '@/store/base'

const storage = window.localStorage
const KEY = StorageKey.MERCHANT_TOKEN

export const tokenStore = hamiVuex.store({
  $name: 'token',
  $state: {
    token: '',
  },
  setToken({ token }) {
    if (!token) {
      storage.removeItem(KEY)
    } else {
      storage.setItem(KEY, token)
    }
    this.$patch({ token })
  },
  loadToken() {
    let token = storage.getItem(KEY)
    if (token) {
      this.$patch({ token })
    }
    return token
  },
})
